function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#bcaaa4",
  d: "M13,16h22v9H13V16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#846e63",
  d: "M13,29.851H9v-5.936L13,16V29.851z M35,29.851h4v-5.936L35,16V29.851z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#b60100",
  d: "M22.015,18.306c0-1.537,0.188-2.762,0.563-3.671c0.377-0.911,1.065-1.808,2.068-2.692 c1.001-0.881,1.668-1.602,2.002-2.157c0.332-0.555,0.496-1.139,0.496-1.755c0-1.856-0.863-2.783-2.589-2.783 c-0.82,0-1.474,0.25-1.966,0.749c-0.492,0.5-0.751,0.801-0.772,1.679H17c0.022-2.095,0.706-3.348,2.051-4.535 c1.343-1.183,3.179-1.777,5.503-1.777c2.347,0,4.166,0.563,5.464,1.689c1.292,1.125,1.94,2.711,1.94,4.765 c0,0.934-0.209,1.814-0.631,2.642c-0.422,0.829-1.157,1.749-2.208,2.759l-1.343,1.267c-0.842,0.802-1.323,1.739-1.445,2.816 l-0.067,1.004L22.015,18.306L22.015,18.306z M21.531,23.348c0-0.733,0.253-1.335,0.757-1.814c0.503-0.475,1.148-0.713,1.934-0.713 c0.786,0,1.43,0.239,1.934,0.713c0.504,0.479,0.757,1.081,0.757,1.814c0,0.719-0.247,1.316-0.74,1.785 c-0.494,0.469-1.145,0.706-1.951,0.706c-0.806,0-1.458-0.237-1.953-0.707C21.778,24.665,21.531,24.068,21.531,23.348z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#edb656",
  d: "M37,45H11c-1.1,0-2-0.9-2-2V24h30v19C39,44.1,38.1,45,37,45z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#846e63",
  d: "M27.372,31h-7c-0.8,0-1.5-0.7-1.5-1.5l0,0c0-0.8,0.7-1.5,1.5-1.5h7c0.8,0,1.5,0.7,1.5,1.5l0,0 C28.872,30.3,28.172,31,27.372,31z"
});

const SvgEmptyBox = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-box.ff1adb6f.svg";
export { ForwardRef as ReactComponent };